export default __webpack_public_path__ + "static/media/betwin95.bae2ca61.svg";